module.exports = __webpack_public_path__ + "static/media/call-outline.ca768739.svg";